import React, { useContext } from 'react';
import ChatbotIcon from './ChatbotIcon';
import '../MapControls.scss';

const ChatbotControl = ({ isOpen, setIsOpen }) => {
  return (
    <button
      type="button"
      className={`mapControl chatbot-control ${isOpen ? 'chatbot-control--active' : ''}`}
      onClick={() => setIsOpen(!isOpen)}
      title="Open Community Assistant"
    >
      <ChatbotIcon />
    </button>
  );
};

export default ChatbotControl;
